var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 4.5,
    height: 8,
    viewBox: "0 0 4.5 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M0.146447 0.146447C-0.0488155 0.341709 -0.0488155 0.658291 0.146447 0.853553L3.29289 4L0.146447 7.14645C-0.0488153 7.34171 -0.0488152 7.65829 0.146447 7.85355C0.341709 8.04882 0.658292 8.04882 0.853554 7.85355L4.35355 4.35355C4.54882 4.15829 4.54882 3.84171 4.35355 3.64645L0.853553 0.146447C0.658291 -0.0488155 0.341709 -0.0488155 0.146447 0.146447Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.c61305967ee349bfcb55093dcc95fbb2.svg";
export { ForwardRef as ReactComponent };